import { MessageType } from '../core/localization';
import { Totals } from '../modules/devices/model';
import { SelectMode, Groups } from './constants';

//export * from './iLog';
export * from '../modules/historical/model';

export interface Action<T> {
  type: string;
  payload?: T;
}

export interface CustomerInfo {
  customerId: string;
  customerName: string;
}

export interface UserInfo {
  userId: string;
  email: string;
  customer: CustomerInfo;
}

export interface EksUser extends UserInfo {
  name: string;
  language: string;
  roles: string[];
}

export interface View {
  groupedBy: Groups;
  mode: SelectMode;
}

export interface GroupCommon {
  numDevices: number;
  totalsByType: Totals;
}

export type ActionButton = {
  id: string;
  title: MessageType;
  subtitle?: MessageType;
  onClick?: () => void;
};

export type FeedbackContent = MessageType;
export interface FeedbackAddPL {
  content: FeedbackContent[];
}

export interface CallStatus {
  isFetching: boolean;
  errorMsg: MessageType;
}
